<template>
    <div class="card shadow-sm mb-2 bg-light">
        <div class="card-header-item p-2">
            <span class="mr-2"><i class="far fa-tasks"></i></span
            >{{ Date.now() | moment('dddd Do MMMM') }}
        </div>
        <div class="card-body p-3">
            <label>Client (facultatif)</label>
            <search-client
                :client-required="false"
                @client-is-set="setClientId"
                @client-is-not-set="resetClientId"
            />
            <b-form-group label="Titre de la tâche" class="mt-3">
                <b-input
                    v-model="form.description"
                    :state="!$v.form.description.$invalid"
                />
                <b-form-invalid-feedback id="assigned_to-feedback">
                    <span v-if="!$v.form.description.required">{{
                            ErrorFeedback.required
                        }}</span>
                </b-form-invalid-feedback>
            </b-form-group>
            <label>Commentaires</label>
            <vue-editor
                id="comments"
                v-model="form.comments"
                class="bg-white"
                :editor-toolbar="customToolbar"
            />
            <div class="row mt-3 mb-1">
                <div class="col-3">
                    <b-form-group label="Affecter cette tâche à">
                        <b-form-select
                            v-model="form.assigned_to"
                            :options="options"
                            size="sm"
                            style="height: 30px"
                            :state="!$v.form.assigned_to.$invalid"
                        />
                        <b-form-invalid-feedback id="assigned_to-feedback">
                            <span v-if="!$v.form.assigned_to.required">{{
                                    ErrorFeedback.required
                                }}</span>
                        </b-form-invalid-feedback>
                    </b-form-group>
                </div>
                <div class="col-3">
                    <label>Echéance</label>
                    <b-input-group>
                        <b-form-input
                            id="current-date"
                            v-model="formatted_deadline_date"
                            type="text"
                            placeholder="Date à définir"
                            autocomplete="off"
                            size="sm"
                            disabled
                            class="bg-white"
                            style="height: 30px"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-form-datepicker
                                v-model="form.deadline_date"
                                button-only
                                right
                                label-no-date-selected="Date à définir"
                                label-prev-year="Année précédente"
                                label-next-year="Année prochaine"
                                label-prev-month="Mois précédent"
                                label-next-month="Mois prochain"
                                label-current-month="Mois actuel"
                                label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                                start-weekday="1"
                                aria-controls="current-date"
                                locale="fr"
                                @context="formatDeadlineDate"
                            >
                            </b-form-datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <div class="col-2">
                    <label>Priorité</label>
                    <b-form-select
                        v-model="form.priority"
                        :options="priorityOptions"
                        size="sm"
                        style="height: 30px"
                    />
                </div>
                <div class="col-1">
                    <b-form-group>
                        <label>Budget (h)</label>
                        <b-input v-model="form.budgeted_duration"
                                 type="numeric"
                                 step="0.1"
                                 size="sm"
                                 class="text-right" />
                    </b-form-group>
                </div>
                <div class="col-3">
                    <b-form-group>
                        <label>Facturation</label>
                        <b-form-select
                            v-model="form.billing_option_id"
                            :options="billableTimeSheetsOptions"
                            size="sm"
                            style="height: 30px"
                            :disabled="!clientIsSet"
                        >
                            <template #first>
                                <b-form-select-option :value="null">
                                    Tâche non facturable
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
            <b-button
                variant="success"
                size="sm"
                :disabled="submitIsDisabled"
                @click="saveEvent"
            >
                <i class="far fa-save fa-fw" />
                <span class="ml-1">Enregistrer</span>
            </b-button>
            <b-button variant="secondary" size="sm" @click="close">
                <i class="far fa-times fa-fw" />
                <span class="ml-1">Annuler</span>
            </b-button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import { Datetime } from 'vue-datetime'
import { VueEditor } from 'vue2-editor'
import { required } from 'vuelidate/lib/validators'
import DataUpdater from '../../../../dashboard/mixins/DataUpdater'
import SearchClient from '../SearchClient'

export default {
    name: 'TaskCreate',

    components: {
        Datetime,
        VueEditor,
        SearchClient
    },

    mixins: [DataUpdater],

    data() {
        return {
            form: {
                // budgeted_duration,
                // priority,
                // assigned_to,
                // billing_option_id
            },
            formatted_deadline_date: '',
            billable: false,
            clientIsSet: false,
            assignedToIsSet: false,
            ErrorFeedback: {
                required: 'Champ obligatoire'
            },
            priorityOptions: [
                { value: 'H', text: 'Haute' },
                { value: 'N', text: 'Normale' },
                { value: 'Z', text: 'Basse' }
            ],
            customToolbar: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }]
            ]
        }
    },

    validations: {
        form: {
            assigned_to: {
                required
            },
            description: {
                required
            }
        }
    },

    created() {
        this.form.priority = 'N'
        this.form.assigned_to = null
        this.form.billing_option_id = null
        this.form.budgeted_duration = 0
    },

    methods: {
        setClientId(client) {
            this.form.client_id = client.id
            this.clientIsSet = true
        },

        resetClientId() {
            this.form.client_id = null
            this.clientIsSet = false
        },

        async saveEvent() {
            try {
                this.form.billable = this.form.billing_option_id !== null
                await axios.post('/clientEvents/task', this.form)
                this.close()
            } catch (error) {
                console.log(error)
            }
        },

        formatDeadlineDate(ctx) {
            this.formatted_deadline_date = ctx.selectedFormatted
        },

        close() {
            this.$store.commit('browsing/RESET_EDITING')
            this.$store.commit('browsing/SET_PAGE_NAME', 'ownTasks')
            window.location = this.menuRoutes.ownTasks
        }
    },

    computed: {
        ...mapState({
            accountingFirmUsers: (state) =>
                state.data.options.accountingFirmUsers,
            billableTimeSheetsOptions: (state) =>
                state.data.options.billableTimeSheets,
            pageName: (state) => state.browsing.pageName,
            menuRoutes: (state) => state.todoVM.menuRoutes
        }),

        options() {
            return this.accountingFirmUsers.filter((item) => item.value !== 0)
        },

        billingSwitchTitle() {
            return this.billable ? 'Tâche facturable' : 'Tâche non facturable'
        },

        formattedDateTime() {
            const dt = new Date(this.ISODateTime)
            const Y = dt.getFullYear()
            const m =
                dt.getMonth() + 1 < 10
                    ? `0${(dt.getMonth() + 1).toString()}`
                    : (dt.getMonth() + 1).toString()
            const d =
                dt.getDate() < 10
                    ? `0${dt.getDate().toString()}`
                    : dt.getDate().toString()
            const H =
                dt.getHours() < 10
                    ? `0${dt.getHours().toString()}`
                    : dt.getHours().toString()
            const i =
                dt.getMinutes() < 10
                    ? `0${dt.getMinutes().toString()}`
                    : dt.getMinutes().toString()
            return `${Y}-${m}-${d} ${H}:${i}`
        },

        submitIsDisabled() {
            return this.$v.$invalid // || !this.clientIsSet
        }
    }
}
</script>

<style scoped>
.card-header-item {
    background-color: #594f47;
    font-size: 12px;
    font-weight: bold;
    color: #fff;
}
</style>
